import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { useAuthStore } from 'store/authStore';
import { useSystemConfigStore } from 'store/systemConfigStore';

interface Props {
  show: boolean;
}

export default function SessionExpiredModal({ show }: Props) {
  const redirectTimeoutSessionExpired = useSystemConfigStore((s) => s.redirectTimeoutSessionExpired);
  const [countdown, setCountdown] = useState(redirectTimeoutSessionExpired);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const { clearAuth } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!show) return;

    setCountdown(redirectTimeoutSessionExpired);

    intervalRef.current = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [show]);

  useEffect(() => {
    if (countdown <= 0) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      clearAuth();
      navigate('/login', { replace: true });
    }
  }, [countdown]);

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>
          <i className="ph ph-lock text-danger me-2" />
          Sesión Expirada
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <i className="ph ph-lock-key text-danger" style={{ fontSize: '3rem' }} />
        <h5 className="mt-3 mb-2">Tu sesión ha expirado</h5>
        <p className="text-muted mb-0">
          Serás redirigido al inicio de sesión en{' '}
          <strong className="text-danger">{countdown}</strong> segundo{countdown !== 1 ? 's' : ''}.
        </p>
      </Modal.Body>
    </Modal>
  );
}
